/**
 * `portal-access/spec.md` → "Interfaz condicionada por permisos, no por
 * el nombre del rol". `GET /auth/me` only exposes `roleCodes`, not
 * resolved permissions (same gap `apps/web-admin/src/orders/
 * order-permissions.ts` already documents), so this mirrors by hand the
 * portal-relevant rows of `apps/api` `role-catalog.ts`
 * (`CLIENT_BUYER`/`CLIENT_MANAGER`/`CLIENT_VIEWER`) — only the four
 * permissions the portal's write actions ever check.
 */
export type PortalOrderPermission =
  'order.create' | 'order.update' | 'order.cancel' | 'order.template.manage';

const ROLES_BY_PERMISSION: Record<PortalOrderPermission, readonly string[]> = {
  'order.create': ['CLIENT_BUYER', 'CLIENT_MANAGER'],
  'order.update': ['CLIENT_BUYER', 'CLIENT_MANAGER'],
  'order.cancel': ['CLIENT_BUYER', 'CLIENT_MANAGER'],
  'order.template.manage': ['CLIENT_BUYER', 'CLIENT_MANAGER'],
};

export function hasOrderPermission(
  roleCodes: readonly string[],
  permission: PortalOrderPermission,
): boolean {
  return roleCodes.some((role) => ROLES_BY_PERMISSION[permission].includes(role));
}
